import { configForCurrency } from "@vb/rgs-contract";

export function formatMultiplier(m: number): string {
  if (m >= 100) return `${m.toFixed(1)}×`;
  return `${m.toFixed(2)}×`;
}

/** Full-precision render with the currency suffix.
 *  Reads decimals from the centralized CURRENCY_CONFIG so adding a new
 *  currency is a one-line config change, not a sprinkled-literal update. */
export function formatCrypto(amount: number, currency: string): string {
  const cfg = configForCurrency(currency);
  return `${amount.toFixed(cfg.decimals)} ${currency}`;
}

/** Same as formatCrypto but without the currency suffix — for cases where
 *  the currency code is rendered as a separate sibling element. */
export function formatCryptoShort(amount: number, currency: string): string {
  const cfg = configForCurrency(currency);
  return amount.toFixed(cfg.decimals);
}

/** Shorter balance render for tight UI chrome (TopBar). Hover/title keeps full precision. */
export function formatCryptoCompact(amount: number, currency: string): string {
  const cfg = configForCurrency(currency);
  return amount.toFixed(cfg.compactDecimals);
}

export function truncateHash(h: string, head = 4, tail = 4): string {
  if (h.length <= head + tail + 1) return h;
  return `${h.slice(0, head)}…${h.slice(-tail)}`;
}

export function roundTag(nonce: number | null | undefined): string {
  if (!nonce || nonce <= 0) return "#—";
  const padded = String(nonce).padStart(6, "0");
  return `#${padded.slice(0, 2)},${padded.slice(2)}`;
}
